import { render, staticRenderFns } from "./shipping-events-held-in-abeyance.vue?vue&type=template&id=65a65f3f&scoped=true&"
import script from "./shipping-events-held-in-abeyance.vue?vue&type=script&lang=js&"
export * from "./shipping-events-held-in-abeyance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a65f3f",
  null
  
)

export default component.exports